import { defineStore } from "pinia"
import apiMine from "@/api/api/apiMine.js"
import { firebaseUtils } from "@/utils/analytic/firebaseUtils.js"
import globalConfig from "@/config/config.js"
import { isDev } from "@/utils/tools.js"

const abtestStore = defineStore({
  id: "abtestStore",
  state: () => {
    return {
      paymentABResult: "",
      subscriptionPriceType: "", // 订阅年度会员价格类型
      subscriptionTabType: ""
    }
  },
  actions: {
    // 上拉加载，
    setABData(data) {
      this.paymentABResult = data
    },
    async initPayment() {
      // 使用 Promise 包装 fastFetchABTest 的异步逻辑
      return new Promise((resolve, reject) => {
        firebaseUtils.abtest.fastFetchABTest({
          param_name: isDev() ? "different_cashier_display_20250314": "different_cashier_display_20250314",
          default_value: "__empty__",
          value_type: "String",
          timeout_milliseconds: 3000,
          custom_properties: {
            platform: globalConfig.platform,
          },
          callback: (result) => {
            console.log("ABresult🔥🔥=>", result);
            this.setABData(result); // 调用 setABData 方法处理结果
            this.paymentABResult = result; // 将结果存储到 paymentABResult 中
            resolve(result); // 将结果传递给 Promise
          },
          error_callback: (error) => {
            console.error("Error fetching AB test result:", error);
            reject(error); // 如果发生错误，reject Promise
          },
        });
      });
    },  
    async getPaymentABResult(){
      if (this.paymentABResult === "") {
        await this.initPayment();
      }
      return this.paymentABResult; // 返回存储的结果
    },
    async clearPaymentABResult(){
      this.paymentABResult = ""
    },
    async initSubscriptionPrice(callbackFun) {
      firebaseUtils.abtest.fastFetchABTest({
        param_name: isDev() ? "yearlysub_price_test_20250212" :"yearlysub_price_test_20250217",
        default_value: "__empty__",
        value_type: "String",
        timeout_milliseconds: 3000,
        custom_properties: {
          platform: globalConfig.platform,
        },
        callback: (result) => {
          console.log("subABresult🔥🔥=>", result)
          this.subscriptionPriceType = result
          callbackFun && callbackFun()
        },
      })
    },
    // 订阅页面tab展示实验
    async initSubscriptionTab(callbackFun) {
      firebaseUtils.abtest.fastFetchABTest({
        param_name: isDev() ? "default_display_monthly_plan_20250219" :"default_display_monthly_plan_20250220",
        default_value: "__empty__",
        value_type: "String",
        timeout_milliseconds: 3000,
        custom_properties: {
          platform: globalConfig.platform,
        },
        callback: (result) => {
          console.log("subTabABresult🔥🔥=>", result)
          this.subscriptionTabType = result
          callbackFun && callbackFun()
        },
      })
    },
  },
})

export default abtestStore
